import { render, staticRenderFns } from "./VIPCameraView.vue?vue&type=template&id=31edc021&"
import script from "./VIPCameraView.vue?vue&type=script&lang=js&"
export * from "./VIPCameraView.vue?vue&type=script&lang=js&"
import style0 from "./VIPCameraView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports